import { useEffect, useState } from "react";

// iOS's keyboard shrinks the visual viewport without reliably changing 100dvh.
// Do not treat pinch-zoom as a keyboard resize or disable accessible zooming.
export function useAssistantViewport(open) {
  const [viewport, setViewport] = useState({ style: {}, keyboardOpen: false });
  useEffect(() => {
    const visual = window.visualViewport;
    if (!open || !visual) return undefined;
    let baseline = Math.max(window.innerHeight, visual.height);
    const update = () => {
      if (Math.abs((visual.scale || 1) - 1) > .02) {
        setViewport({ style: {}, keyboardOpen: false });
        return;
      }
      const focused = document.activeElement?.id === "assistant-message-input";
      if (!focused) baseline = Math.max(window.innerHeight, visual.height);
      const keyboardOpen = focused && baseline - visual.height > 100;
      setViewport({
        style: { height: `${visual.height}px`, top: `${Math.max(0, visual.offsetTop)}px`, bottom: "auto" },
        keyboardOpen,
      });
    };
    update();
    visual.addEventListener("resize", update);
    visual.addEventListener("scroll", update);
    window.addEventListener("resize", update);
    document.addEventListener("focusin", update);
    document.addEventListener("focusout", update);
    return () => {
      visual.removeEventListener("resize", update);
      visual.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      document.removeEventListener("focusin", update);
      document.removeEventListener("focusout", update);
    };
  }, [open]);
  return viewport;
}
